import { Grid, GridItem, Text } from "@chakra-ui/react";
import React from "react";
import CustomInput from "../../../components/UI/CustomInput";

export default function Password({ payload, setPayload, errors = {}, validateRequiredField }) {
  return (
    <Grid className="simple-modal-grid" templateColumns="140px 1fr">
      <GridItem className="simple-modal-label">
        <Text>New Password</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          required
          minLength={8}
          error={errors.newPassword}
          onFocus={() => validateRequiredField("newPassword", "The Password field is required")}
          type="password"
          name="client-new-password"
          autoComplete="new-password"
          onChange={(e) => {
            setPayload({
              ...payload,
              newPassword: e.target.value,
            });
          }}
        />
      </GridItem>
      <GridItem className="simple-modal-label">
        <Text>Confirm Password</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          required
          minLength={8}
          error={errors.confirmPassword}
          onFocus={() => validateRequiredField("confirmPassword", "The Confirm Password field is required")}
          type="password"
          name="client-confirm-password"
          autoComplete="new-password"
          onChange={(e) => {
            setPayload({
              ...payload,
              confirmPassword: e.target.value,
            });
          }}
        />
      </GridItem>
      <GridItem className="simple-modal-label">
        <Text>Transaction Password</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          required
          minLength={6}
          error={errors.transactionPassword}
          onFocus={() => validateRequiredField("transactionPassword", "The Transaction Code field is required")}
          type="password"
          name="client-password-transaction-code"
          autoComplete="new-password"
          onChange={(e) => {
            setPayload({
              ...payload,
              transactionPassword: e.target.value,
            });
          }}
        />
      </GridItem>
    </Grid>
  );
}
